<template>
    <div class="profits">
        <div class="common-search-container common-shadow">
            <div class="common-header">
                用户效益明细
            </div>
            <div class="content">
                <el-form
                    :inline="true"
                    :model="searchParams"
                    @keyup.native.enter="getData">
                    <el-form-item label="">
                        <el-input
                            v-model="searchParams.nickname"
                            placeholder="用户名"
                            clearable />
                    </el-form-item>
                    <el-form-item label="">
                        <el-input
                            v-model="searchParams.mobile"
                            placeholder="手机号"
                            clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker
                            v-model="date"
                            type="daterange"
                            format="yyyy-MM-dd"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            unlink-panels
                            @change="onDateChange" />
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            type="primary"
                            round
                            @click="getData">
                            查询
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div>
            <div class="common-table-title">
                <span class="tit">
                    数据列表
                </span>
            </div>
            <el-table
                class="table common-shadow"
                stripe
                :data="tableData"
                v-loading="loading"
                @sort-change="onSortChange">
                <el-table-column
                    prop="nickname"
                    label="用户名"
                    min-width="90" />
                <el-table-column
                    prop="avatar"
                    label="头像"
                    min-width="90">
                    <template slot-scope="scope">
                        <img :src="scope.row.avatar">
                    </template>
                </el-table-column>
                <el-table-column
                    prop="subscribe_count"
                    label="参与次数"
                    sortable="custom"
                    min-width="130" />
                <el-table-column
                    prop="amount"
                    label="参与总金额"
                    sortable="custom"
                    min-width="158" />
                <el-table-column
                    prop="profit"
                    label="总收益"
                    sortable="custom"
                    min-width="142" />
                <el-table-column
                    prop="from_shared_profit"
                    label="额外收益"
                    sortable="custom"
                    min-width="114" />
                <el-table-column
                    align="center"
                    label="操作"
                    min-width="80">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="goDetails(scope.row.nickname)">
                            查看明细
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="common-table-pagination">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page="searchParams.page"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="dataTotal" />
            </div>
        </div>
    </div>
</template>

<script>
import { getCrowdFundUserDetailList } from '../../../../api';
import { dateFormat } from '../../../../utils/util';

export default {
    name: 'CrowdFundUserDetail',
    data () {
        return {
            date: null,
            searchParams: {
                nickname: '',
                mobile: '',
                order: '',
                page: 1,
                start: '',
                end: ''
            },
            loading: false,
            tableData: [],
            pageSize: 0,
            dataTotal: 0,
            isExporting: false
        };
    },
    created () {
        this.getData();
    },
    methods: {
        async getData (page) {
            try {
                this.loading = true;
                if (typeof page === 'number') {
                    this.searchParams.page = page;
                } else {
                    this.searchParams.page = 1;
                }
                const res = await getCrowdFundUserDetailList(this.searchParams);
                if (res) {
                    const { data, meta } = res;
                    if (data) this.tableData = data;
                    if (meta) {
                        this.dataTotal = meta.total;
                        this.pageSize = meta.per_page;
                    }
                }
            } catch (err) {
                console.error(err);
            } finally {
                this.loading = false;
            }
        },
        handleCurrentChange (val) {
            this.getData(val);
        },
        dateFormat (time) {
            if (!time) return '';
            return dateFormat(new Date(time * 1000), 'yyyy-MM-dd hh:mm');
        },
        onDateChange (e) {
            if (e) {
                this.searchParams.start = e[0];
                this.searchParams.end = e[1];
            } else {
                this.searchParams.start = '';
                this.searchParams.end = '';
            }
        },
        goDetails (nickname) {
            this.$router.push({
                name: 'crowdFund.detail.user',
                query: {
                    nickname
                }
            });
        },
        onSortChange ({ prop, order }) {
            const { searchParams } = this;
            if (order) {
                if (order === 'ascending') {
                    order = 'asc';
                } else {
                    order = 'desc';
                }
                searchParams.order = `${prop}_${order}`;
            } else {
                searchParams.order = '';
            }
            this.getData(1);
        }
    }
};
</script>

<style lang="scss" scoped>
.profits {

    .table {

        img {
            width: 32px;
            height: 32px;
            object-fit: cover;
        }
    }
}
</style>
